import React, { useState } from "react";
import "./SideNavbar.scss";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import EPICENTERLOGO from "../../assets/images/epicenter_logo.png";
import studentSidebaricon from "../../assets/images/studentSidebaricon.png";
import community_updated_icon from "../../assets/images/community_updated_icon.gif";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import EventRoundedIcon from "@material-ui/icons/EventRounded";
import DvrOutlinedIcon from "@material-ui/icons/DvrOutlined";
import CastForEducationOutlinedIcon from "@material-ui/icons/CastForEducationOutlined";
import TableChartOutlinedIcon from "@material-ui/icons/TableChartOutlined";
//import PhotoCameraFrontOutlinedIcon from '@material-ui/icons/PhotoCameraFrontOutlined';
//import GroupsOutlinedIcon from '@material-ui/icons/GroupsOutlined';
import PeopleOutlinedIcon from "@material-ui/icons/PeopleOutlined";
import AssignmentIndOutlinedIcon from "@material-ui/icons/AssignmentIndOutlined";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import { decrypt } from "../../utils/others";
import { isMentorLikeRole } from "../../utils/auth";
import { reducer_clearBreadCrumbs } from "../../Redux/Actions/folderPath.action";
import { useLocation, useHistory } from "react-router-dom";
import swal from "sweetalert";
import { useSelector, useDispatch } from "react-redux";
import { fireEpicenterGtm } from "../../datalayers";
import { NAV_GTM_ACTIONS } from "./navGtmActions";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import sandbox_logo from "../../assets/images/sandbox_logo.png";
import { openSandboxAsMentor } from "../../utils/cySso";
import AuthErrorModal from "./AuthErrorModal";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import FaceIcon from "@material-ui/icons/Face";
import LoopIcon from "@material-ui/icons/AllInclusive";
import CampaignIcon from "@mui/icons-material/Campaign";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import Badge from "@material-ui/core/Badge";
import OndemandVideoOutlinedIcon from "@material-ui/icons/OndemandVideoOutlined";
import payoutIcon from "../../assets/images/payout.png";
import { useChatUnread } from "../Chat/ChatUnreadContext";
import { useUnwatchedCount } from "../MyCourses/UnwatchedCountContext";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    overflowX: "hidden",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflow: "hidden",
    backgroundColor: "#FFF8F5",
    display: "flex",
    flexDirection: "column",
    height: "100vh",
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflow: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
    backgroundColor: "#FFF8F5",
    display: "flex",
    flexDirection: "column",
    height: "100vh",
  },
  navScrollOpen: {
    flexGrow: 1,
    minHeight: 0,
    overflowY: "auto",
  },
  navScrollClosed: {
    flexGrow: 1,
    minHeight: 0,
    overflow: "hidden",
  },
  payoutText: {
    "& .MuiListItemText-primary": {
      transform: "translateY(6px)",
    },
  },
}));


export default function SideNavigationBar() {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const path = useSelector((state) => state.folderPathReducer.folderPath);
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const roles = decrypt(localStorage.getItem("user"));
  // Mentor LMS req 5/7: a temp mentor rides this SAME navbar (App.jsx routes
  // both roles here) but sees ONLY "Tutorials" — every other item below is
  // `isMentor`-only. `isMentorLike` (shared helper) covers just that one item
  // plus the outer render gate.
  const isMentor = roles.role === "mentor";
  const isMentorLike = isMentorLikeRole(roles.role);
  const { unreadCount } = useChatUnread();
  const { unwatchedCount } = useUnwatchedCount();
  const history = useHistory();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const logOut = () => {
    swal({
      title: "Logout",
      text: "Do you really want to logout?",
      buttons: ["No", "Yes, Logout"],
      closeOnClickOutside: false,
      closeOnEsc: false,
    }).then((logout) => {
      if (logout) {
        fireEpicenterGtm("nav_logout_clicked", ["", "side_nav"]);
        localStorage.removeItem("user");
        localStorage.removeItem("workShift");
        window.location.replace("/");
      }
    });
  };
  const sandBoxLogin = () => {
    fireEpicenterGtm("nav_sandbox_clicked", ["", "side_nav"]);
    setLoader(true);
    openSandboxAsMentor()
      .then(() => {
        setLoader(false);
      })
      .catch((e) => {
        setLoader(false);
        console.error("Error while creating auth token", e);
      });
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const closeErrorModal = () => {
    setLoader(false);
  };

  const navigateTo = (to) => {
    if (path.length > 0) {
      dispatch(reducer_clearBreadCrumbs());
    }
    const action = NAV_GTM_ACTIONS[to] || "/";

    // Counts the tracking sheet asks for as event_label1, where the nav already
    // has the number to hand; the rest of the items send no first label.
    const count =
      to === "/my-courses"
        ? unwatchedCount
        : to === "/chat"
          ? unreadCount
          : "";

    fireEpicenterGtm(action, [count ?? "", "side_nav"]);
    history.push(to);
  };

  return (
    <>
      <div className={classes.root}>
        {loader && (
          <AuthErrorModal open={loader} closeModals={closeErrorModal} />
        )}
        <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            }),
          }}
          onMouseEnter={handleDrawerOpen}
          onMouseLeave={handleDrawerClose}
        >
          <List>
            <ListItem style={{ paddingLeft: "0px", paddingTop: "0px" }}>
              <ListItemIcon>
                <img
                  src={EPICENTERLOGO}
                  alt="epicenter"
                  style={{ marginLeft: "2%", height: "50px", width: "230px" }}
                />
              </ListItemIcon>
            </ListItem>
          </List>
          <Divider />
          <div
            className={open ? classes.navScrollOpen : classes.navScrollClosed}
          >
            <List>
              {[
                {
                  text: "Dashboard",
                  to: "/mentorDashboard",
                  allow: isMentor,
                  icon: DashboardOutlinedIcon,
                },
                {
                  // req 6: near the top of the nav (right after Dashboard),
                  // not buried at the bottom — was the last item before this.
                  text: "Tutorials",
                  to: "/my-courses",
                  // The ONLY item a temp mentor sees (req 5/7).
                  allow: isMentorLike,
                  icon: OndemandVideoOutlinedIcon,
                  isTutorials: true,
                },
                {
                  text: "Slots",
                  to: "/slots",
                  allow: isMentor,
                  icon: EventRoundedIcon,
                },
                {
                  text: "Demos",
                  to: "/demos",
                  allow: isMentor,
                  icon: DvrOutlinedIcon,
                },

                {
                  text: "Classes",
                  to: "/classes",
                  allow: isMentor,
                  icon: CastForEducationOutlinedIcon,
                },
                {
                  text: "Time table",
                  to: "/timetable",
                  allow: isMentor,
                  icon: TableChartOutlinedIcon,
                },
                {
                  text: "Students",
                  to: "/student-manage",
                  allow: isMentor,
                  icon: FaceIcon,
                },
                {
                  text: "Sandbox",
                  to: null,
                  allow: isMentor,
                  icon: () => (
                    <img
                      src={sandbox_logo}
                      style={{
                        fontSize: "45px",
                        height: "30px",
                        paddingLeft: "6px",
                      }}
                    />
                  ),
                  isSandbox: true,
                },
                {
                  text: "Loop",
                  to: "/loop",
                  allow: isMentor,
                  icon: LoopIcon,
                },

                {
                  text: "Resources",
                  to: "/mentorResources",
                  allow: isMentor,
                  icon: LibraryBooksIcon,
                },
                {
                  text: "Community",
                  to: "/community",
                  allow: isMentor,
                  icon: PeopleOutlinedIcon,
                },
                {
                  text: "Chat",
                  to: "/chat",
                  allow: isMentor,
                  icon: ChatBubbleOutlineIcon,
                  isChat: true,
                },

                {
                  text: "Profile",
                  to: "/mentors",
                  allow: isMentor,
                  icon: AssignmentIndOutlinedIcon,
                },
                {
                  text: "Referral",
                  to: "/referral",
                  allow: isMentor,
                  icon: CampaignIcon,
                },
                {
                  text: "Payout",
                  to: "/payout",
                  allow: isMentor,
                  icon: () => (
                    <img
                      src={payoutIcon}
                      alt="payout"
                      className={`payout-icon ${location.pathname.includes("/payout") ? "active" : ""}`}
                      style={{ width: "12px" }}
                    />
                  ),
                },
                {
                  text: "Tasks",
                  to: "/tasks",
                  allow: isMentor,
                  icon: AssignmentOutlinedIcon,
                },
              ].map((route, index) => {
                // route.allow was previously dead here (nothing checked it).
                // Now needed: temp mentors ride this same navbar (req 5/7) and
                // must see only "Tutorials", not the full mentor nav.
                if (!route.allow) return null;
                const isReferral =
                  location.pathname.includes("/referral") ||
                  location.pathname.includes("/refer-mentors");
                if (isMentorLike) {
                  if (route.isSandbox) {
                    return (
                      <ListItem
                        button
                        key="sandboxLogin"
                        onClick={sandBoxLogin}
                        style={{
                          color: "#BCA987",
                          paddingLeft: 10,
                          marginTop: -10,
                        }}
                      >
                        <ListItemIcon>
                          <route.icon />
                        </ListItemIcon>
                        <ListItemText
                          style={{ fontSize: "21px", paddingLeft: 6 }}
                          primary={route.text}
                        />
                      </ListItem>
                    );
                  }

                  return (
                    <>
                      <ListItem
                        button
                        key={route.text}
                        onClick={() => navigateTo(route.to)}
                        style={{
                          color:
                            route.text === "Referral"
                              ? isReferral
                                ? "#F66C28"
                                : "#BCA987"
                              : location.pathname.includes(route.to)
                                ? "#F66C28"
                                : "#BCA987",
                          backgroundColor:
                            route.text === "Referral"
                              ? isReferral
                                ? "#FFF8F5"
                                : ""
                              : location.pathname.includes(route.to)
                                ? "#FFF8F5"
                                : "",
                          paddingLeft: 18,
                          marginBottom: 7,
                          paddingTop: matches ? 0 : 4,
                        }}
                      >
                        <ListItemIcon
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          {(() => {
                            const icon = (
                              <route.icon
                                // width="48"
                                style={{
                                  color:
                                    route.text === "Referral"
                                      ? isReferral
                                        ? "#F66C28"
                                        : "#BCA987"
                                      : location.pathname.includes(route.to)
                                        ? "#F66C28"
                                        : "#BCA987",
                                  fontSize: "30px",
                                  height: "20px",
                                }}
                              />
                            );
                            if (route.isChat) {
                              return (
                                <Badge
                                  badgeContent={unreadCount}
                                  color="error"
                                  overlap="circle"
                                  invisible={!unreadCount}
                                  anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                  }}
                                  style={{ marginRight: 12 }}
                                >
                                  {icon}
                                </Badge>
                              );
                            }
                            if (route.isTutorials) {
                              return (
                                <Badge
                                  badgeContent={unwatchedCount}
                                  // req 6: exact count up to 9, "9+" for 10 or more.
                                  max={9}
                                  color="error"
                                  overlap="circle"
                                  invisible={!unwatchedCount}
                                  anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                  }}
                                  style={{ marginRight: 12 }}
                                >
                                  {icon}
                                </Badge>
                              );
                            }
                            return icon;
                          })()}
                        </ListItemIcon>
                        <ListItemText
                          primary={route.text}
                          className={
                            route.text === "Payout" ? classes.payoutText : ""
                          }
                          style={{ fontSize: "21px" }}
                        />
                        {route.text === "Community" && (
                          <img
                            src={community_updated_icon}
                            alt="community"
                            width="60px"
                            height="24px"
                            location={location.pathname.includes("community")}
                          />
                        )}
                      </ListItem>
                    </>
                  );
                }
              })}
            </List>
          </div>
          <ListItem
            button
            key="Logout"
            onClick={logOut}
            style={{
              color: location.pathname.includes("/") ? "#FF3333" : "",
              backgroundColor: location.pathname.includes("/") ? "#FFD6D6" : "",
              paddingLeft: 18,
              marginTop: "auto",
              flexShrink: 0,
            }}
          >
            <ListItemIcon>
              <PowerSettingsNewIcon
                // width="48"
                style={{
                  color: location.pathname.includes("/") ? "#FF3333" : "",
                  fontSize: "20px",
                }}
              />
            </ListItemIcon>
            <ListItemText style={{ fontSize: "21px" }} primary="Logout" />
          </ListItem>
        </Drawer>
      </div>
    </>
  );
}
